'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _dec, _class; // Lib


// Util


// Services


// Selectors


var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactRedux = require('react-redux');

var _lodash = require('lodash');

var _milanoteReselect = require('../milanoteReselect/milanoteReselect');

var _boardService = require('../../element/board/boardService');

var _socketChannelSelector = require('./socketChannelSelector');

var _socketChannelSelector2 = _interopRequireDefault(_socketChannelSelector);

var _boardSelector = require('../../element/board/boardSelector');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var mapStateToProps = (0, _milanoteReselect.createShallowSelector)(_socketChannelSelector2.default, _boardSelector.getFetchedBoardIds, function (_ref, fetchedBoardIds) {
    var boardChannels = _ref.boardChannels;
    return {
        boardChannels: boardChannels,
        fetchedBoardIds: fetchedBoardIds
    };
});

var mapDispatchToProps = function mapDispatchToProps(dispatch) {
    return {
        dispatchRefreshIfModified: function dispatchRefreshIfModified(boardId) {
            return dispatch((0, _boardService.refreshIfModified)({ boardId: boardId }));
        }
    };
};

var RefreshStaleBoardManager = (_dec = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps), _dec(_class = function (_React$Component) {
    _inherits(RefreshStaleBoardManager, _React$Component);

    function RefreshStaleBoardManager() {
        _classCallCheck(this, RefreshStaleBoardManager);

        return _possibleConstructorReturn(this, (RefreshStaleBoardManager.__proto__ || Object.getPrototypeOf(RefreshStaleBoardManager)).apply(this, arguments));
    }

    _createClass(RefreshStaleBoardManager, [{
        key: 'componentWillReceiveProps',
        value: function componentWillReceiveProps(nextProps) {
            var dispatchRefreshIfModified = nextProps.dispatchRefreshIfModified,
                boardChannels = nextProps.boardChannels,
                fetchedBoardIds = nextProps.fetchedBoardIds;


            if (boardChannels !== this.props.boardChannels) {
                var newBoardChannels = (0, _lodash.difference)(boardChannels, this.props.boardChannels);
                newBoardChannels.forEach(function (boardId) {
                    // Haven't retrieved the board yet so no need checking if it's been modified
                    if (!(0, _lodash.includes)(fetchedBoardIds, boardId)) return;

                    dispatchRefreshIfModified(boardId);
                });
            }
        }
    }, {
        key: 'render',
        value: function render() {
            return _react2.default.Children.only(this.props.children);
        }
    }]);

    return RefreshStaleBoardManager;
}(_react2.default.Component)) || _class);


RefreshStaleBoardManager.propTypes = {
    children: _propTypes2.default.element.isRequired,
    boardChannels: _propTypes2.default.array,
    fetchedBoardIds: _propTypes2.default.array,
    dispatchRefreshIfModified: _propTypes2.default.func
};

exports.default = RefreshStaleBoardManager;


//////////////////
// WEBPACK FOOTER
// ./src/client/utils/collaboration/RefreshStaleBoardManager.js
// module id = 2115
// module chunks = 0